import Bannerpic from '../banner.png';
import React, { useState } from 'react'
import { FaBars , FaTimes } from 'react-icons/fa';
export const Header = () => {

  const [icon, setIcon] = useState(false)
  const handleClick = () =>{
      setIcon(!icon)
  }
  const closeSideDrawer = () =>{
      setIcon(false)
  }


  return (
    <div className='header'>
      <div className='bg-red'>
        <div className="logo">
          <h3>TRAINR</h3>
          <ul className={ icon ? 'nav-menu active' : 'nav-menu'}>
            <li><a href='/' className = 'nav-links' onClick={closeSideDrawer}>Home</a></li>
            <li><a href='#services' className = 'nav-links' onClick={closeSideDrawer}>Services</a></li>
            <li><a href='#about' className = 'nav-links' onClick={closeSideDrawer}>Training</a></li>
            <li><a href='#gallery' className = 'nav-links' onClick={closeSideDrawer}>Gallery</a></li>
            <li><a href='#plans' className = 'nav-links' onClick={closeSideDrawer}>Pricing</a></li>
          </ul></div>

        <div className='banner-content'>
          <div>
            <h3>Build Your <span>Core Strength</span></h3>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero dicta incidunt exercitationem itaque nostrum molestias suscipit quod quis voluptates eveniet, neque nam, adipisci asperiores culpa temporibus porro sunt similique ab?</p>
          <button className='btn-1'>START TODAY</button>
          </div>
          <div className="bannerpic">
          <img src={Bannerpic} alt='banner' />
          </div>
          
        </div>
        
      </div>
      <div className='bg-white'>
        <button className='btn-contact'><a href='#contact'>Contact</a></button>
      </div>

      <div className='menu-icon' onClick={handleClick}>{
        icon ? <FaTimes className='fa-times'></FaTimes> : <FaBars className='fa-bars'></FaBars> }
        </div>

    </div>
  )
}
